/* Block - Form.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 */
/* eslint-disable-next-line */
import styles from "./block-form.scss";

const hashLikeAddressPattern = /^[a-f0-9]{32}$/i;
const orderFormAddressFields = [
    "field_7qpf4_line1",
    "field_7qpf4_city",
    "field_7qpf4_state",
    "field_7qpf4_zip",
    "field_6wx1w_line1",
    "field_6wx1w_city",
    "field_6wx1w_state",
    "field_6wx1w_zip",
];

function setAddressValidationError(input, message) {
    const container = input.closest(".frm_form_field");
    input.setCustomValidity(message);

    if (!container) {
        return;
    }

    container.classList.add("frm_blank_field");

    let error = container.querySelector(".frm_error");

    if (!error) {
        error = document.createElement("div");
        error.className = "frm_error";
        error.setAttribute("role", "alert");
        container.appendChild(error);
    }

    error.textContent = message;
}

function clearAddressValidationError(input) {
    const container = input.closest(".frm_form_field");
    input.setCustomValidity("");

    if (!container) {
        return;
    }

    container.classList.remove("frm_blank_field");

    const error = container.querySelector(".frm_error");

    if (error && error.textContent === "Please enter a valid address.") {
        error.remove();
    }
}

function validateGiftCardOrderAddressFields(form) {
    let isValid = true;
    let firstInvalidField = null;

    orderFormAddressFields.forEach((fieldId) => {
        const input = form.querySelector(`#${fieldId}`);

        if (!input) {
            return;
        }

        if (hashLikeAddressPattern.test(input.value.trim())) {
            setAddressValidationError(input, "Please enter a valid address.");
            isValid = false;
            firstInvalidField = firstInvalidField || input;
        } else {
            clearAddressValidationError(input);
        }
    });

    if (firstInvalidField) {
        firstInvalidField.reportValidity();
        firstInvalidField.focus();
    }

    return isValid;
}

function preventGiftCardOrderHashAddressSubmit(event, form) {
    if (!form) {
        return;
    }

    if (!validateGiftCardOrderAddressFields(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
}

document.addEventListener(
    "click",
    (event) => {
        const submitButton = event.target.closest(".gift-card-order-form .frm_final_submit");

        if (!submitButton) {
            return;
        }

        preventGiftCardOrderHashAddressSubmit(event, submitButton.closest("form"));
    },
    true
);

document.addEventListener(
    "submit",
    (event) => {
        const form = event.target;

        if (!(form instanceof HTMLFormElement) || !form.classList.contains("gift-card-order-form")) {
            return;
        }

        preventGiftCardOrderHashAddressSubmit(event, form);
    },
    true
);

document.addEventListener("input", (event) => {
    const input = event.target;

    if (!(input instanceof HTMLInputElement) || !orderFormAddressFields.includes(input.id)) {
        return;
    }

    if (!hashLikeAddressPattern.test(input.value.trim())) {
        clearAddressValidationError(input);
    }
});
